import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@UntilDestroy()
@Component({
  selector: 'rma-back-to-map',
  templateUrl: './back-to-map.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, RmaIconComponent, TranslocoPipe],
  host: {
    class: 'fixed z-50 m-auto inset-x-0 top-5',
  },
})
export class BackToMapComponent {
  @Input()
  mapElement: ElementRef;

  backToMap() {
    this.mapElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
}
